export default "__VITE_ASSET__Bi3NlBrc__"